document.addEventListener('DOMContentLoaded', function () {
  const menuIcon = document.getElementById('mobile-menu');
  const menuButton = document.getElementById('mobile-button');
  if (!menuIcon || !menuButton) return;
  menuButton.addEventListener('click', function () {
    menuIcon.classList.toggle('hidden');
  });
});